import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'
import { statusStr } from '@/constants/transactionStatus'
import DescriptionColumn from "../../gateway/components/transactions-report-details-column";

const detailsTemplate = (row, index, datatable) => {
    let template = new DescriptionColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}

export default [
    {
        field: 'traceCode',
        title: i18n.t('transactions-report.traceCode'),
        sortable: false,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'referenceCode',
        title: i18n.t('transactions-report.referenceCode'),
        sortable: false,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'transactionDate',
        title: i18n.t('transactions-report.transactionDate'),
        sortable: true,
        textAlign: 'center',
        width: 90,
    },
    {
        field: 'price',
        title: i18n.t('transactions-report.price'),
        sortable: true,
        textAlign: 'center',
        width: 90
    },
    {
        field: 'status',
        sortable: true,
        title: i18n.t('transactions-report.status'),
        textAlign: 'center',
        template: (row) => {
            let variant
            let status_str
            if (row.status === 'SUCCEED') {
                variant = 'badge-success'
                status_str = statusStr.SUCCEED
            } else if (row.status === 'REVERSED') {
                variant = 'badge-warning'
                status_str = statusStr.REVERSED
            }
            else {
                variant = 'badge-danger'
                status_str = statusStr.FAILED
            }

            return '<div class="badge '+variant+' text-white">'+ status_str+'</div>'
        },
        width: 80
    },
    {
        field: 'transactionDetails',
        sortable: false,
        title: i18n.t('label.description'),
        width: 80,
        textAlign: 'center',
        template: (row, index, datatable) => {
            return detailsTemplate(row, index, datatable)
        },
    },
]